module.exports = __webpack_public_path__ + "fonts/cges-icons.f106f8f7.eot";